var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error-auth"},[_c('div',{staticClass:"error-auth__message"},[_vm._v("ログインエラー")]),_c('a',{staticClass:"error-auth__link",attrs:{"href":_vm.returnPage}},[_vm._v("戻る")])])
}
var staticRenderFns = []

export { render, staticRenderFns }